/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { OneClick } from '@/components/blocks/OneClick';
import { Stack } from '@mui/material';
import { FC, useMemo } from 'react';

type Props = {
	isReadyToAddToCart: boolean;
	onAddToCart: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
};

export const BundleAddToCart: FC<Props> = ({ isReadyToAddToCart, onAddToCart }) => {
	const dtId = useMemo(() => `bundle-add-to-cart`, []);

	return (
		<Stack marginY="16px">
			<OneClick
				data-testid={dtId}
				id={dtId}
				onClick={onAddToCart}
				variant="contained"
				disabled={!isReadyToAddToCart}
				sx={{ backgroundColor: '#727272' }}
			>
				{'Agregar al carrito'}
			</OneClick>
		</Stack>
	);
};
